export const getTagName = (node: Element) => node.tagName.replace('svg:', '');
